import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasUnaccreditedInstitutionSchema = withDefaults({
  type: 'tas-unaccredited-institution',
  fields: [
    {
      kind: 'attribute',
      name: 'address',
    },
    {
      kind: 'attribute',
      name: 'locationName',
    },
    {
      kind: 'attribute',
      name: 'locationType',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default TasUnaccreditedInstitutionSchema;
